
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading, { type StateChanger } from 'vue-infinite-loading'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumLoadResult } from '@xt/client/entities/content/controller'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiStationery } from '@xt/client'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Bind, Debounce } from 'lodash-decorators'
import { stationeryGroupName } from '@xt/client/dataSource/stationery/index'
import { LoadResult } from '@xt/client/types/stationery.d'

type PageMeta = {
  inited: boolean
  isLoading: boolean
  hasMore: boolean
  page: number
  pageSize: number
  lastId: number | undefined
}

@Component({
  components: {
    EmptyStatus,
    InfiniteLoading,
    LazyImg
  }
})
export default class Content extends Vue {
  @Prop() active: number

  dataSource: LoadResult[] = []
  pageMeta: PageMeta = {
    inited: false,
    isLoading: false,
    hasMore: true,
    page: 0,
    pageSize: 20,
    lastId: undefined
  }

  // 解决底部空间过高，导致加载更多不触发的问题
  get contentStyle() {
    return this.pageMeta.hasMore ? undefined : { marginBottom: this.$px2rem(379) }
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  @Emit('handle-click')
  handleClick(item) {
    return {
      path: item.pageUrl,
      alias: item.alias
    }
  }

  getGroupNameByActive(): string {
    return stationeryGroupName[this.active] || ''
  }

  async fetchData(): Promise<EnumLoadResult> {
    const { isLoading, page, hasMore, pageSize, lastId } = this.pageMeta

    if (isLoading) return EnumLoadResult.Cancel

    if (!hasMore) return EnumLoadResult.Complete

    try {
      this.updatePageMeta({ isLoading: true })

      const [error, list] = await $service<Array<LoadResult>>({
        method: 'GET',
        url: EnumApiStationery.ProductsV2,
        params: {
          page: page + 1,
          pageSize,
          groupName: this.getGroupNameByActive(),
          lastId
        }
      })

      if (error) return EnumLoadResult.Error

      this.appendList(list)

      this.updatePageMeta({
        inited: true,
        page: page + 1,
        hasMore: list.length === pageSize,
        lastId: list.length ? list[list.length - 1].id : lastId
      })

      // 是否还有更多数据状态处理
      return list.length === pageSize ? EnumLoadResult.Loaded : EnumLoadResult.Complete
    } finally {
      this.updatePageMeta({ isLoading: false })
    }
  }

  appendList(newList: LoadResult[]) {
    this.dataSource = [...this.dataSource, ...newList]
  }

  updatePageMeta(args: Partial<PageMeta>) {
    this.pageMeta = {
      ...this.pageMeta,
      ...args
    }
  }

  @Debounce(200, { leading: true, trailing: false })
  @Bind()
  async infiniteHandler($state: StateChanger) {
    const res = await this.fetchData()

    if (res === EnumLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (res === EnumLoadResult.Error) {
      $state.error()
    }

    if (res === EnumLoadResult.Loaded) {
      $state.loaded()
    }

    if (res === EnumLoadResult.Complete) {
      if (this.dataSource.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  activated(): void {
    if (!this.$store.$global.production) {
      console.log('activated', this.active)
    }
  }

  deactivated(): void {
    if (!this.$store.$global.production) {
      console.log('deactivated', this.active)
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
